import React from 'react';
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import 'react-toastify/dist/ReactToastify.css';

import './styles/index.css';
import App from './App';
import { Provider } from "react-redux";
import store, { persistor } from './redux/store';  // ✅ single import, correct path
import { ToastContainer } from 'react-toastify';
import { createRoot } from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { GlobalWorkerOptions } from 'pdfjs-dist';

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js')
//       .then(registration => {
//         console.log('Service Worker registered:', registration);
//       })
//       .catch(error => {
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer bodyStyle={{ fontFamily: "Roboto" }} />
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);